import { useWorkflowNodesForDisplay } from 'modules/workflowWebhooksIndex/hooks';
import { WorkflowNodeEntry } from 'modules/workflowWebhooksIndex/components/WorkflowWebhookNameCell.styles';
import { SecondaryButton } from 'ui/button';
import { Detail, DetailHeader, DetailBody, Link } from './WorkflowWebhookDetails.styled';
import type { WorkflowWebhook } from '../types';

type Props = {
  webhook: WorkflowWebhook;
  onEdit: () => void;
};

export const WorkflowWebhookInfo = ({ webhook, onEdit }: Props) => {
  const workflows: any = useWorkflowNodesForDisplay(webhook?.workflowNodes);

  return (
    <>
      <Detail>
        <DetailHeader>Name</DetailHeader>
        <DetailBody>{webhook.name}</DetailBody>
        <DetailHeader>Journey tiles</DetailHeader>
        <DetailBody>
          {Object.keys(workflows).length === 0
            ? 'None'
            : Object.keys(workflows).map((k: any) => {
                const workflow = workflows[k];
                return (
                  <WorkflowNodeEntry key={`workflow-${k}`}>
                    <Link href={`/workflows/${k}/edit`}>{workflow.name}</Link> (Node IDs:{' '}
                    {workflow.nodes.map((nodeId: number, nodeIdx: number) => (
                      <span key={nodeId}>
                        {nodeId}
                        {nodeIdx === workflow.nodes.length - 1 ? '' : ', '}
                      </span>
                    ))}
                    ) &nbsp;
                  </WorkflowNodeEntry>
                );
              })}
        </DetailBody>
      </Detail>
      <SecondaryButton onClick={onEdit}>Edit details</SecondaryButton>
    </>
  );
};
